import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuestRoute from "../components/feature/GuestRoute";
import AcceptInvitePage from "../pages/accept-invite/page";
import PricingPage from "../pages/pricing/page";
import LoginPage from "../pages/auth/LoginPage";
import SignUpPage from "../pages/auth/SignUpPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import DashboardLayout from "../pages/dashboard/components/DashboardLayout";
import DashboardPage from "../pages/dashboard/page";
import ProfilesPage from "../pages/profiles/page";
import ProfileFormPage from "../pages/profiles/form/page";
import GeneratePage from "../pages/generate/page";
import VideoAdsPage from "../pages/video-ads/page";
import AudioStudioPage from "../pages/audio-studio/page";
import HistoryPage from "../pages/history/page";
import SettingsPage from "../pages/settings/page";
import EditorPage from "../pages/editor/page";
import VideoEditorPage from "../pages/video-editor/page";
import BillingPage from "../pages/billing/page";
import ExportPage from "../pages/export/page";
import SocialPostPage from "../pages/social-post/page";
import AIAdGeneratorPage from "../pages/ai-ad-generator/page";
import FeaturesPage from "../pages/features/page";
import HowItWorksPage from "../pages/how-it-works/page";
import PrivacyPolicyPage from "../pages/privacy/page";
import TermsOfServicePage from "../pages/terms/page";
import LogoPreviewPage from "../pages/logo-preview/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import ContractorsPage from "../pages/contractors/page";
import SmallBusinessPage from "../pages/small-business/page";
import EcommercePage from "../pages/ecommerce/page";
import RealEstatePage from "../pages/real-estate/page";
import LocalServicesPage from "../pages/local-services/page";
import QuickStartPage from "../pages/quick-start/page";
import SocialQuickStartPage from "../pages/social-quick-start/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <GuestRoute>
        <Home />
      </GuestRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "profiles", element: <ProfilesPage /> },
      { path: "profiles/new", element: <ProfileFormPage /> },
      { path: "profiles/:id/edit", element: <ProfileFormPage /> },
      { path: "generate", element: <GeneratePage /> },
      { path: "video-ads", element: <VideoAdsPage /> },
      { path: "audio-studio", element: <AudioStudioPage /> },
      { path: "history", element: <HistoryPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "billing", element: <BillingPage /> },
      { path: "editor", element: <EditorPage /> },
      { path: "video-editor", element: <VideoEditorPage /> },
      { path: "export", element: <ExportPage /> },
      { path: "social-post", element: <SocialPostPage /> },
    ],
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/quick-start",
    element: <QuickStartPage />,
  },
  {
    path: "/social-quick-start",
    element: <SocialQuickStartPage />,
  },
  {
    path: "/ai-ad-generator",
    element: <AIAdGeneratorPage />,
  },
  {
    path: "/features",
    element: <FeaturesPage />,
  },
  {
    path: "/how-it-works",
    element: <HowItWorksPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <SignUpPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "/logo-preview",
    element: <LogoPreviewPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/ai-ads-for-contractors",
    element: <ContractorsPage />,
  },
  {
    path: "/ai-ads-for-small-business",
    element: <SmallBusinessPage />,
  },
  {
    path: "/ai-ads-for-ecommerce",
    element: <EcommercePage />,
  },
  {
    path: "/ai-ads-for-real-estate",
    element: <RealEstatePage />,
  },
  {
    path: "/ai-ads-for-local-services",
    element: <LocalServicesPage />,
  },
  {
    path: "/accept-invite",
    element: <AcceptInvitePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
